export const CREATE_PELLE = "CREATE_PELLE";
export const RETRIEVE_PELLES = "RETRIEVE_PELLES";
export const UPDATE_PELLE = "UPDATE_PELLE";
export const DELETE_PELLE = "DELETE_PELLE";
export const DELETE_ALL_PELLES = "DELETE_ALL_PELLES";